import { Component, OnInit } from '@angular/core';
import { ErrorNotificationService } from '../services/error-notification.service';

export interface AlertDialogConfig {
  id?: string;
  timestamp?: number;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  isConfirm?: boolean;
  isCancel?: boolean;
  isClose?: boolean;
  isError?: boolean;
  isSuccess?: boolean;
  isWarning?: boolean;
  isInfo?: boolean;
  isDetails?: boolean;
  isLoading?: boolean;
  isLoadingMessage?: string;
  isLoadingTitle?: string;
  type: 'info' | 'warning' | 'error' | 'success';
  details?: Array<any>;
}

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.template.html',
  styleUrls: ['./alert-dialog.component.scss'],

  standalone: false,})
export class AlertDialogComponent implements OnInit {
  data: AlertDialogConfig = {
    title: '',
    message: '',
    confirmLabel: 'Confirmer',
    type: 'info',
    details: [],
  };
  showAlert = false;
  alertType = 'info';
  icon = 'info';
  closed = false;
  isConfirm = false;

  constructor(private alertService: ErrorNotificationService) {}

  ngOnInit(): void {
    this.alertService.alertState.subscribe((config: AlertDialogConfig) => {
      this.open(config);
    });

    this.alertService.closeState.subscribe((close: boolean) => {
      this.close();
    });
  }

  open(data: AlertDialogConfig): void {
    this.alertType = data.type === 'error' ? 'danger' : data.type;
    this.showAlert = true;
    this.closed = !this.showAlert;
    this.data = {
      ...data,
      id: data.id || `alert-${Date.now()}`,
      timestamp: Date.now(),
      details: data.details || [],
    };
    this.icon = data.type;
  }

  close(): void {
    this.showAlert = false;
    this.closed = !this.showAlert;
    if (this.data) {
      this.data.isLoading = false;
    }
  }

  hasDetails(): boolean {
    return !!this.data && Array.isArray(this.data.details) && this.data.details.length > 0;
  }

  getDetailsAsString(): string {
    if (!this.hasDetails()) return '';
    return (this.data.details ?? [])
      .map((detail: any, index: number) =>
        typeof detail === 'string'
          ? `${index + 1}. ${detail}`
          : `${index + 1}. ${JSON.stringify(detail, null, 2)}`,
      )
      .join('\n');
  }

  get isDetailsArray(): boolean {
    return !!this.data && !!this.data.details && Array.isArray(this.data.details);
  }

  onConfirm(): void {
    this.alertService.resolveConfirm(true);
    this.close();
  }

  onCancel(): void {
    this.alertService.resolveConfirm(false);
    this.close();
  }

  closeLoading(): void {
    this.alertService.closeAlert();
  }
}
